export default __webpack_public_path__ + "static/media/ojo.347afbe9.svg";